<template>
	<div>
		<el-button type="primary" @click="announceClick" style="float: right;margin:15px 20px 15px;">发布公告</el-button>
		<section>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column prop="title" label="标题" align="center"></el-table-column>
				<el-table-column prop="sendName" label="姓名" align="center"></el-table-column>
				
				<el-table-column prop="noticeType" label="分类" align="center"></el-table-column>
				<el-table-column label="发布时间" align="center">
					<template slot-scope="{row}">{{setTime(row.createTime)}}</template>
				</el-table-column>
				<el-table-column label="是否置顶" align="center">
					<template slot-scope="{row}">{{row.top==1?"不置顶":"置顶"}}</template>
				</el-table-column>
				<el-table-column label="是否回执" align="center">
					<template slot-scope="{row}">{{row.receipt==1?"不回执":"回执"}}</template>
				</el-table-column>
				<el-table-column label="是否弹出显示" align="center">
					<template slot-scope="{row}">{{row.eject==1?"不弹出显示":"弹出显示"}}</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="{row}">
						<el-button size="mini" @click="show=true;html=row.content">查看内容</el-button>
						<el-button size="mini" @click="delRow(row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background :page-size="size" layout="total, prev, pager, next,sizes" @current-change="handleCurrentChange"
			 :total="totalNum" @size-change="handleSizeChange" />
		</section>
		<el-dialog title="公告内容" :visible.sync="show" width="30%">
			<div v-html="html"></div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false">取 消</el-button>
				<el-button type="primary" @click="show = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				html:"",
				show: false,
				tableData: [],
				totalNum: 0,
				page: 1,
				size: 10,
			}
		},
		mounted() {
			this.getAll();
		},
		methods: {
			delRow(obj) {
				this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(`/api/notice/deleteNotice?id=${obj.id}`).then(res => {
						if (res.data.code == 0) {
							this.getAll()
							this.$message.success("删除成功")
						} else {
							this.$message.error("删除失败")
						}
					})
				}).catch(() => {});
			},
			getAll() {
				this.$http.post(`/api/notice/queryNotice`, {
					currentPage: this.page,
					pageSize: this.size
				}).then(res => {
					this.totalNum = res.data.data.totalNum
					this.tableData = res.data.data.items
				})
			},
			// 发布公告
			announceClick() {
				this.$router.push("/index/message/announce");
			},
			// 查看
			checkClick() {

			},

			// 分页
			// 当前页
			handleCurrentChange(val) {
				console.log(val);
				this.currentPage = val;
				this.getAll();
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.getAll();
			},

		},
	}
</script>

<style>
</style>
